import { navLinks, siteName } from "@/mocks/site";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-secondary-800 text-secondary-50">
      <div className="w-full px-4 md:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2 flex flex-col gap-4 max-w-md">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50 text-lg">
                <i className="ri-book-2-fill" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-2xl leading-none">{siteName}</span>
            </div>
            <p className="text-secondary-100/80 text-sm leading-relaxed">
              抖漫漫画聚合韩漫、动漫、国漫等丰富内容，提供免费在线观看与高清阅读体验，实时更新最新漫画章节，
              帮助你快速找到想要的资源入口。
            </p>
            <p className="text-secondary-200/70 text-xs leading-relaxed">
              本站为内容聚合展示页，页面内的作品、榜单与更新信息仅用于导航与信息聚合，具体内容以作品实际页面为准。
            </p>
          </div>

          <nav aria-label="页脚导航" className="flex flex-col gap-3">
            <h4 className="font-heading text-lg text-secondary-50">站内导航</h4>
            <ul className="flex flex-col gap-2">
              {navLinks.slice(0, 4).map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-secondary-100/80 text-sm hover:text-primary-300 transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="页脚更多导航" className="flex flex-col gap-3">
            <h4 className="font-heading text-lg text-secondary-50">更多内容</h4>
            <ul className="flex flex-col gap-2">
              {navLinks.slice(4).map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-secondary-100/80 text-sm hover:text-primary-300 transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <a href="#top" className="text-secondary-100/80 text-sm hover:text-primary-300 transition-colors">
                  回到顶部
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-500/40 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-secondary-200/70">
          <p>© {year} {siteName} · 漫画大全内容聚合演示页</p>
          <p>关键词：抖漫 · 韩漫 · 国漫 · 动漫 · 免费漫画 · 最新漫画</p>
        </div>
      </div>
    </footer>
  );
}